import * as React from 'react';
import Immutable from 'immutable';
import { useIntl } from 'react-intl';

import { ToolTip } from '../ToolTip';
import { addModifiers, getLanguageCode } from '../../shared/helpers';
import { formatMessageHelper, FormattedMessageHelper } from '../../shared/helpers/internationalization';

interface AlphaPerformanceSummaryProps {
  title: string;
  titleValues?: Record<string, string | number>;
  tooltipUrl: string;
  data: Immutable.List<any>;
}

export function AlphaPerformanceSummary({ title, titleValues, data, tooltipUrl }: AlphaPerformanceSummaryProps) {
  const intl = useIntl();
  return (
    <>
      <div className="summary-metrics-aggregate">
        <div className="summary-metrics-aggregate-title">
          <FormattedMessageHelper id={title} values={titleValues} />
        </div>
      </div>
      {data &&
        data.map((columnElement: any, index: any) => {
          const modifiers =
            columnElement && columnElement.get('modifiers') ? ['data'].concat(columnElement.get('modifiers').toJS()) : ['data'];

          return (
            <div className="summary-metrics-info" key={index}>
              <div className={addModifiers('summary-metrics-info', ['title'])}>
                {formatMessageHelper(intl, columnElement.get('title'))}
                <ToolTip
                  label={`${columnElement.get('tooltip')}.label`}
                  tooltipInfo={`${columnElement.get('tooltip')}.content`}
                  url={tooltipUrl}
                />
              </div>
              <div className={addModifiers('summary-metrics-info', modifiers)}>
                {columnElement.get('value') !== null ? columnElement.get('value').toLocaleString(getLanguageCode()) : '-'}
              </div>
            </div>
          );
        })}
    </>
  );
}
